import React from 'react';

import { useRouterContext } from '../router/context';

import { defaultMatcher } from './default-matcher';
import type { IProps } from './models';

/** Компонент, который рендерит содержимое, если роут совпал */
export const Route = <S,>({
    children,
    invert = false,
    matcher = defaultMatcher,
    name,
}: IProps<S>) => {
    const { route } = useRouterContext<S>();

    const render = matcher<S>({ name, route, invert });

    return render ? <>{children}</> : null;
};
